import axios from 'axios';
import getApiError from 'services/getApiError';
import { ShopProductSummary } from 'services/shops/interface';
import useSWR from 'swr';

interface GetShopProductDetailsBasedOnIdParams {
  shopProductId: string;
}

export const getShopProductDetailsBasedOnId = async ({
  shopProductId
}: GetShopProductDetailsBasedOnIdParams) => {
  const url = `${process.env.REACT_APP_FILTER_API_HOST}/api/v1/shop-products/${shopProductId}`;
  const response = await axios.get<ShopProductSummary>(url);

  return response?.data;
};

interface UseShopProductDetailsParams {
  shopProductId: string;
}

const useShopProductDetails = ({
  shopProductId
}: UseShopProductDetailsParams) => {
  const { data, isValidating, error } = useSWR(
    shopProductId ? `/shop_product/${shopProductId}` : null,
    () => {
      if (!shopProductId) {
        return null;
      }

      return getShopProductDetailsBasedOnId({ shopProductId });
    },
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false
    }
  );
  const isFetchingShopProductDetails = !data && !error && isValidating;

  return {
    isFetchingShopProductDetails,
    shopProduct: data,
    error: getApiError(error)
  };
};

export default useShopProductDetails;
